import { render } from "./FacebookInsights.vue?vue&type=template&id=58184ebe&scoped=true"
import script from "./FacebookInsights.vue?vue&type=script&lang=js"
export * from "./FacebookInsights.vue?vue&type=script&lang=js"

import "./FacebookInsights.vue?vue&type=style&index=0&id=58184ebe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58184ebe"]])

export default __exports__